<template>

  <DataView :value="parameters" :layout="'grid'" :rows="8" class="data-grid-parameters"
                :paginator="false" paginatorTemplate="PrevPageLink CurrentPageReport NextPageLink"
                currentPageReportTemplate="{currentPage} / {totalPages}"
    >

    <template #empty>
      <div class="p-m-4">-</div>
    </template>

    <template #grid="slotProps">
      <div v-if="slotProps.data.type==='sanigen'" class="p-col-12 p-md-6 nested-grid data-grid-parameter" >
        <Sanigen :serialNumber="serialNumber" size="small"/>
      </div>
      <div v-else-if="!slotProps.data.hidden" class="p-col-12 p-md-6 nested-grid data-grid-parameter" >
        <div :class="['p-grid', 'p-ai-center', {'gray': slotProps.data.disabled}, {'clickable': slotProps.data.click!=null}]"
           @click="slotProps.data.click">
          <div class="p-col-fixed p-text-center data-grid-parameter-icon">
            <i v-if="slotProps.data.icon.spinner" class="cycle-spinner cycle-spinner-spin">
              <span :class="slotProps.data.icon.class" :style="slotProps.data.icon.style"/>
            </i>
            <span v-else :class="slotProps.data.icon.class" :style="slotProps.data.icon.style"/>
          </div>
          <div class="p-col data-grid-parameter-text">
            <span>{{slotProps.data.text}}</span>
          </div>
          <div class="p-col-fixed p-text-center data-grid-parameter-value" :style="slotProps.data.valueDivStyle">
            <span>{{slotProps.data.value}}</span> 
          </div>
          <div class="param-cta">
            <i v-if="slotProps.data.click!=null" class="pi pi-chevron-right" />
          </div>
        </div>
      </div>
    </template>

  </DataView>

  <!--                    -->
  <!-- ERRORS and SUCCESS -->
  <!--                    -->
  <IrinoxDialogDark :visible="dialog.error" 
    mode="error" 
    :message="$t('details.mp.function_1.dialog_error')"
    :life="3000" 
    @update:visible="dialog.error = $event" />
  <IrinoxDialogDark :visible="dialog.blockingError" 
    mode="error" 
    :message="$t('details.mp.function_1.dialog_error')"
    :life="0" 
    @update:visible="dialog.blockingError = $event" />
  <IrinoxDialogDark :visible="dialog.success" 
    mode="success" 
    :message="$t('details.mp.function_1.dialog_success')"
    :life="3000" 
    @update:visible="dialog.success = $event" />

  <!--                -->
  <!-- DEFROST DIALOG -->
  <!--                -->
  <IrinoxDialogDark :visible="dialog.defrost_turn_on" 
    mode="confirm" 
    :leftB="$t('details.cp.defrost_dialog_cancel_button')" 
    @click:left-button="()=>{dialog.defrost_turn_on=!dialog.defrost_turn_on}" 
    :rightB="$t('details.cp.defrost_dialog_ok_button')" 
    @click:right-button="defrost(true)" 
    :message="$t('details.cp.defrost_turn_on_dialog')"
    icon="assets/irinox/icons/defrost_big.svg" />


  <!--                      -->
  <!-- HUMIDITY TEMP DIALOG -->
  <!--                      -->
  <Dialog v-model:visible="dialog.editParameters" class="irinox-dialog-dark" :modal="true" 
      :closable="true" :dismissableMask="true" :draggable="false">
    
    <div class="irinox-dialog-dark-content">
      <div class="p-grid nested-grid p-jc-center controls">
        <div class="p-col">
          <Control v-model="setpoint.airTemp" icon="icon-air_temp" :isTemperature="true" :min="limits.cellSetTempMin" :max="limits.cellSetTempMax" />
        </div>
        <div :class="['p-col', {'disabled':limits.setPercentHumidityMin==null && limits.setPercentHumidityMax==null}]" >
          <Control v-model="setpoint.humidity" icon="icon-humidity" :isPercentage="true" :min="limits.setPercentHumidityMin" :max="limits.setPercentHumidityMax" />
        </div>
        <div class="p-col">
          <Control v-model="setpoint.fan" icon="icon-fan" :min="limits.evapFanSetSpeedMin" :max="limits.evapFanSetSpeedMax" />
        </div>
        <!-- <div class="p-col">
          <Control v-model="setpoint.phaseDuration" icon="icon-time" :isTime="true" :min="limits.phaseDurationSetMin" :max="limits.phaseDurationSetMax"/>
        </div> -->
      </div>
      <Button :label="$t('details.mp.function_1.editParameters_dialog_cancel_button')" @click="()=>{dialog.editParameters=!dialog.editParameters}" style="width: 150px"/>
      <Button :label="$t('details.mp.function_1.editParameters_dialog_ok_button')" class="p-button-secondary" @click="saveSetpoint" style="width: 150px"/>
    </div>

    <template #footer>
    </template>
  </Dialog>

  <!--                      -->
  <!-- CONSERVAZIONE DIALOG -->
  <!--                      -->
  <Dialog v-model:visible="dialog.editHolding" class="irinox-dialog-dark" :modal="true" 
      :closable="true" :dismissableMask="true" :draggable="false">
    
    <div class="irinox-dialog-dark-content">
      <div class="p-grid nested-grid p-jc-center controls">
        <div class="p-col">
          <Control v-model="setpoint.airTemp" icon="icon-air_temp" :isTemperature="true" :min="limits.cellSetTempMin" :max="limits.cellSetTempMax" />
        </div>
        <div :class="['p-col', {'disabled':limits.setPercentHumidityMin==null && limits.setPercentHumidityMax==null}]" >
          <Control v-model="setpoint.humidity" icon="icon-humidity" :isPercentage="true" :min="limits.setPercentHumidityMin" :max="limits.setPercentHumidityMax" />
        </div>
        <div class="p-col-fixed p-d-flex p-ai-center" style="width:200px">
          <SelectButton class="coldMode" v-model="setpoint.coldMode" :options="coldModes" optionLabel="name" optionValue="code"/>
        </div>
      </div>
      <Button :label="$t('details.mp.function_1.editParameters_dialog_cancel_button')" @click="()=>{dialog.editHolding=!dialog.editHolding}" style="width: 150px"/>
      <Button :label="$t('details.mp.function_1.editParameters_dialog_ok_button')" class="p-button-secondary" @click="saveSetpoint" style="width: 150px"/>
    </div>

    <template #footer>
    </template>
  </Dialog>

</template>

<script>
import IrinoxDialogDark from '../../IrinoxDialogDark.vue';
import Sanigen from '../Sanigen.vue';
import Control from '../Control.vue';
import cycles from "@/cycles";
import { mapGetters } from 'vuex';
import EventHubListenerService from '../../../service/EventHubListenerService';
import commands from "../../../../public/json/commands_mp_1.json"

export default {
    components: {
      IrinoxDialogDark,
      Control,
      Sanigen,
    },
    props: {
      serialNumber: String
    },
    data() {
        return {
          cycles: cycles,
          commands: commands,
          coldModes: [
            { 
              code: 1,
              name: this.$t('details.mp.function_1.coldMode_1') 
            },{ 
              code: 2,
              name: this.$t('details.mp.function_1.coldMode_2') 
            }
          ],
          dialog: {
            error: false,
            blockingError: false,
            success: false,
            editParameters: false,
            editHolding: false,
            defrost_turn_on: false,
          },
          setpoint: {
            airTemp: null,
            humidity: null,
            fan: null,
            phaseDuration: null,
            coldMode: null
          },
          parameters: [],
          limits: {
            cellSetTempMin: null,
            cellSetTempMax: null,
            setPercentHumidityMin: null,
            setPercentHumidityMax: null,
            evapFanSetSpeedMin: null,
            evapFanSetSpeedMax: null,
          }
        };
    },
    computed: {
        ...mapGetters({
          personaltoken: 'userdata/personaltoken',
          unit: 'userdata/unit',
          role: 'userdata/role',
          deviceTwin: 'appliances/deviceTwin',
          isCelsius: 'userdata/isCelsius',
          is24hour: 'userdata/is24hour',
        }),
        readOnlyMode: function() {
          return this.role.includes('INTERNAL') || this.role==='SERVICE_SALES';
        },
        appliance: function() {
            return this.$store.getters['appliances/appliance'](this.serialNumber);
        },
        mode: function() {
          return this.appliance.status && this.appliance.status.mode!=null ? this.appliance.status.mode : 0;
        },
        mpCycleRunning: function() {
          return this.appliance.online && this.deviceTwin && this.deviceTwin.status && [1,2,3].includes(this.mode);
        },
        mpDefrost: function() {
          return this.appliance.online && this.deviceTwin && this.deviceTwin.status && this.mode===4;
        },
        mpNonStop: function() {
          return this.appliance.online && this.deviceTwin && this.deviceTwin.status && this.mode===1;
        },
        currentPhase: function() {
          let cyclePhaseNumber = this.appliance.cycle.cyclePhaseNumber;
          let cycleTotalPhases = this.appliance.cycle.cycleTotalPhases;
          return (cyclePhaseNumber!=null?cyclePhaseNumber:"-") + " / " + (cycleTotalPhases!=null?cycleTotalPhases:"-");
        },
        timeSinceStart: function() {
          try {
            //phaseDurationSet is in seconds
            let time = this.mpCycleRunning && this.appliance.cycle &&  this.appliance.cycle.timeSinceStart ? this.appliance.cycle.timeSinceStart / 60 : null;
            //time in minutes
            if(time) {
              var hours = Math.floor(time / 60);
              time = time - hours * 60;
              var minutes = Math.floor(time);
              return (hours<10?"0"+hours:hours)+"h:"+(minutes<10?"0"+minutes:minutes)+"m";
            }
          } catch(err) {
            return "N/A";
          }
          return "--h:--m";
        },
        cycleEndTime: function() {
          if(this.appliance.cycle && this.appliance.cycle.cycleEndTime) {
            return this.$d(new Date(this.appliance.cycle.cycleEndTime*1000), this.is24hour ? "cycle" : "cycle12");
          }
          return "-";
        },
        initMaintenanceHumidity: function() {
          return this.mpCycleRunning && this.appliance.cycle ? this.appliance.cycle.initMaintenanceHumidity : "-";
        },
        initMaintenanceTemperature: function() {
          return this.mpCycleRunning && this.appliance.cycle ? this.appliance.cycle.initMaintenanceTemperature : "-";
        },
        endInitMaintenance: function() {
          if(this.appliance.cycle && this.appliance.cycle.endInitMaintenance) {
            return this.$d(new Date(this.appliance.cycle.endInitMaintenance*1000), this.is24hour ? "time" : "time12");
          }
          return "-";
        },
        endRumUp: function() {
          if(this.appliance.cycle && this.appliance.cycle.endRumUp) {
            return this.$d(new Date(this.appliance.cycle.endRumUp*1000), this.is24hour ? "time" : "time12");
          }
          return "-";
        },
        cellSetTemp: function() {
          return this.mpCycleRunning && this.appliance.status ? this.appliance.status.cellSetTemp : null
        },
        setPercentHumidity: function() {
          return this.mpCycleRunning && this.appliance.status ? this.appliance.status.setPercentHumidity : null
        },
        evapFanSetSpeed: function() {
          return this.mpCycleRunning && this.appliance.status ? this.appliance.status.evapFanSetSpeed : null
        },
        setPointFinalTemp: function() {
          return this.mpCycleRunning && this.deviceTwin.status ? this.deviceTwin.status.setPointFinalTemp : 40;
        }
    },
    watch: {
      appliance: 'buildParameters',
      role: 'buildParameters',
      'deviceTwin.status': 'buildParameters',
      'mode': 'updateLimits',
      'setPointFinalTemp': 'updateLimits',
      'cellSetTemp': 'updateLimits',
      'setpoint.airTemp': 'updateLimits'
    },
    created() {
      this.eventHubListenerService = new EventHubListenerService();
    },
    mounted() {
      this.buildParameters();
      this.updateLimits();
    },
    methods: {
      buildParameters() {
        this.parameters[0] = {
          click: null,
          disabled: !(this.mpCycleRunning || this.mpDefrost),
          icon: {
            spinner: false,
            class: this.mpCycleRunning ? "icon-leavening_"+this.mode : (this.mpDefrost ? "icon-defrosting" : "")
          },
          text: this.$t('details.mp.function_1.mode_'+this.mode),
          value: null,
          valueDivStyle: "min-width: unset !important;"
        }
        this.parameters[1] = {
          click: null,
          disabled: !this.mpCycleRunning || this.mpNonStop,
          icon: {
            spinner: false,
            class: this.mpCycleRunning ? "icon-leavening_"+this.mode : (this.mpDefrost ? "icon-defrosting" : "")
          },
          text: this.appliance.cycle ? this.$t('mp.function_1.phases.'+this.appliance.cycle.phaseRunning) : this.$t('mp.function_1.phases.0'),
          value: this.mpCycleRunning && !this.mpNonStop ? this.currentPhase : null,
          valueDivStyle: !this.mpCycleRunning || this.mpNonStop ? "min-width: unset !important;" : null
        }
        this.parameters[2] = {
          click: this.mpNonStop && !this.readOnlyMode ? this.editParameters : (this.mpCycleRunning && !this.mpNonStop && !this.readOnlyMode ? this.editHolding : null),
          disabled: !this.mpCycleRunning,
          icon: {
            spinner: false,
            class: "icon-humidity"
          },
          text: this.mpCycleRunning && !this.mpNonStop ? this.$t('details.mp.function_1.humidity_level_holding') : this.$t('details.mp.function_1.humidity_level'),
          value: this.mpCycleRunning ? this.setPercentHumidity+"%" : "-%"
        }
        this.parameters[3] = {
          click: this.mpNonStop && !this.readOnlyMode ? this.editParameters : (this.mpCycleRunning && !this.mpNonStop && !this.readOnlyMode ? this.editHolding : null),
          disabled: !this.mpCycleRunning,
          icon: {
            spinner: false,
            class: "icon-air_temp"
          },
          text: this.mpCycleRunning && !this.mpNonStop ? this.$t('details.mp.function_1.air_temp_holding') : this.$t('details.mp.function_1.air_temp'),
          value: this.mpCycleRunning ? this.$functions.temperature(this.cellSetTemp, this.isCelsius)+this.unit : "-"+this.unit
        }
        this.parameters[4] = {
          click: this.mpNonStop && !this.readOnlyMode ? this.editParameters : null,
          disabled: !this.mpCycleRunning,
          icon: {
            spinner: false,
            class: "icon-fan"
          },
          text: this.$t('details.mp.function_1.fan_level'),
          value: this.mpCycleRunning ? this.evapFanSetSpeed : "-"
        }
        this.parameters[5] = {
          click: null,
          disabled: !this.mpCycleRunning,
          icon: {
            spinner: false,
            class: "icon-time_play"
          },
          text: this.$t('details.mp.function_1.time_since_start'),
          value: this.timeSinceStart
        }
        this.parameters[6] = {
          click: null,
          disabled: !this.mpCycleRunning || this.mpNonStop,
          icon: {
            spinner: false,
            class: "icon-time"
          },
          text: this.$t('details.mp.function_1.cycle_end_time'),
          value: this.cycleEndTime
        }
        // this.parameters[7] = {
        //   click: this.mpCycleRunning && !this.mpNonStop ? this.editHolding : null,
        //   disabled: !this.mpCycleRunning || this.mpNonStop,
        //   icon: {
        //     spinner: false,
        //     class: "icon-air_temp"
        //   },
        //   text: this.$t('details.mp.function_1.holding'),
        //   value: null,
        //   valueDivStyle: "min-width: unset !important;"
        // }

        this.parameters = this.parameters.slice(0,7);

        if(this.mode===2) {
          this.parameters.push({
            // hidden: this.mode!==2,
            click: null,
            disabled: false,
            icon: {
              spinner: false,
              class: "icon-humidity"
            },
            text: this.$t('details.mp.function_1.holding_humidity_start'),
            value: this.initMaintenanceHumidity+"%"
          });
          this.parameters.push({
            // hidden: this.mode!==2,
            click: null,
            disabled: false,
            icon: {
              spinner: false,
              class: "icon-air_temp"
            },
            text: this.$t('details.mp.function_1.holding_temperature_start'),
            value: this.$functions.temperature(this.initMaintenanceTemperature, this.isCelsius)+this.unit
          });
          this.parameters.push({
            // hidden: this.mode!==2,
            click: null,
            disabled: false,
            icon: {
              spinner: false,
              class: "icon-wake1"
            },
            text: this.$t('details.mp.function_1.end_holding_initial'),
            value: this.endInitMaintenance
          });
          this.parameters.push({
            // hidden: this.mode!==2,
            click: null,
            disabled: false,
            icon: {
              spinner: false,
              class: "icon-wake1"
            },
            text: this.$t('details.mp.function_1.end_rumpup'),
            value: this.endRumUp
          });
        }

        this.parameters.push({
          click: this.mode!==4 && !this.readOnlyMode ? this.defrostDialog : null,
          disabled: this.mode===4,
          icon: {
            spinner: false,
            class: "icon-defrosting"
          },
          text: this.$t('details.cp.defrost_switched_off'),
          value: null,
          valueDivStyle: "min-width: unset !important;"
        });

        this.parameters.unshift({ type: "sanigen"});
      },
      updateLimits() {
        try {
          if(this.mpCycleRunning) {
            let p = this.commands.modes[this.mode];
            if(p) {
              let lim = this.$functions.clone(p);
              if(lim.cellSetTempMin) {
                lim.cellSetTempMin*=10;
              }
              if(lim.cellSetTempMax!=null) {
                let getTempLimit = Function("finalTemp", "return "+lim.cellSetTempMax);
                lim.cellSetTempMax = getTempLimit(Math.floor(this.setPointFinalTemp/10))*10;
              }
              if(lim.setPercentHumidityMin) {
                const fw = this.appliance?.currentSoftwareVersion ?? null;
                const newFw = fw !== null && this.$functions.compareVersionStrings(fw, "1.7") >= 0;
                let getHumidityLimit = Function("temp", "newFw", "return "+lim.setPercentHumidityMin);
                lim.setPercentHumidityMin = getHumidityLimit(
                  this.setpoint.airTemp!=null ? this.setpoint.airTemp : this.cellSetTemp,
                  newFw
                );
              }
              if(lim.setPercentHumidityMax) {
                let getHumidityLimit = Function("temp", "return "+lim.setPercentHumidityMax);
                lim.setPercentHumidityMax = getHumidityLimit(this.setpoint.airTemp!=null ? this.setpoint.airTemp : this.cellSetTemp);
              }
              this.limits = lim;
              return;
            }
          }
        } catch(err) {
          console.warn("Error parsing commands " + err);
        }
        this.limits = {
          cellSetTempMin: null,
          cellSetTempMax: null,
          setPercentHumidityMin: null,
          setPercentHumidityMax: null,
          evapFanSetSpeedMin: null,
          evapFanSetSpeedMax: null,
          // phaseDurationSetMin: null,
          // phaseDurationSetMax: null
        };
      },  
      editParameters() {
        this.setpoint.airTemp = this.cellSetTemp;
        this.setpoint.humidity = this.setPercentHumidity;
        this.setpoint.fan = this.evapFanSetSpeed;
        this.setpoint.coldMode = null;
        // this.setpoint.phaseDuration = this.appliance.cycle.phaseDuration / 60;
        this.dialog.editParameters = true;
      },
      editHolding() {
        this.setpoint.airTemp = this.cellSetTemp;
        this.setpoint.humidity = this.setPercentHumidity;
        this.setpoint.fan = null;
        this.setpoint.coldMode = this.deviceTwin.status ? this.deviceTwin.status.coldMode : 0;
        this.dialog.editHolding = true;
      },
      saveSetpoint() {
        let data = {};
        if(this.setpoint.airTemp != null) {
          data.cellSetTemp = this.setpoint.airTemp;
        }
        if(this.setpoint.humidity != null && this.limits.setPercentHumidityMin != null && this.limits.setPercentHumidityMax != null) {
          data.setPercentHumidity = this.setpoint.humidity;
        }
        if(this.setpoint.fan != null) {
          data.evapFanSetSpeed = this.setpoint.fan;
        }
        if(this.setpoint.coldMode != null) {
          data.coldMode = this.setpoint.coldMode;
        }

        this.dialog.editHolding = false;
        this.dialog.editParameters = false;
        this.eventHubListenerService.postSetSetpoint(this.personaltoken, this.serialNumber, data)
          .then((response) => {
            if(response.code=="200") {
              this.dialog.success = true;
              let app = this.$functions.clone(this.appliance);
              if(data.cellSetTemp!=null) {
                app.status.cellSetTemp = data.cellSetTemp;
              }
              if(data.setPercentHumidity!=null) {
                app.status.setPercentHumidity = data.setPercentHumidity;
              }
              if(data.evapFanSetSpeed!=null) {
                app.status.evapFanSetSpeed = data.evapFanSetSpeed;
              }
              this.$store.commit('appliances/applianceDetails', app);

              if(data.coldMode!=null) {
                let dt = this.$functions.clone(this.deviceTwin);
                dt.status.coldMode = data.coldMode;
                this.$store.commit('appliances/deviceTwin', dt);
              }
            } else {
              console.error("EXCEPTION "+JSON.stringify(response));
              this.dialog.error = true;
            }
          })
          .catch(error => {
            console.error("EXCEPTION "+error);
            this.dialog.error = true;
          });
      },
      saveHolding() {
        alert("SAVE HOLDING");
      },
      defrostDialog() {
        this.dialog.defrost_turn_on = true;
      },
      defrost() {
        this.setOperationalStatus("defrost");
      },
      setOperationalStatus(os) {

        let data = {
          operationalStatus: os
        }

        this.dialog.defrost_turn_on = false;
        this.eventHubListenerService.postSetOperationalStatus(this.personaltoken, this.serialNumber, data)
          .then((data) => {
            if(data.code=="200") {
              this.dialog.success = true;
              // let app = this.$functions.clone(this.appliance);
              // app.status.operationalStatus = os;
              // this.$store.commit('appliances/applianceDetails', app);
            } else {
              console.error("EXCEPTION "+JSON.stringify(data));
              this.dialog.error = true;
            }
          })
          .catch(error => {
            console.error("EXCEPTION "+error);
            this.dialog.error = true;
          });
        },
  }
}
</script>

<style scoped>

.disabled {
  /* visibility: hidden; */
  opacity: 0.5;
}

</style>